<template>
  <!-- <a-config-provider :locale="zh_CN"> -->
  <a-config-provider :locale="locale">
    <div id="app">
        <!-- html部分 -->
        <div class='mask' v-if="$store.getters.loading"></div>
        <!-- 提示层 -->
        <div class='board' v-if="$store.getters.loading">
          <!-- v-if="$store.getters.loading" -->
            <div style="text-align: center;">
              <img src="./assets/image/loading.gif">
              <div style="color: #fff;">{{$store.getters.tips}}</div>
            </div>
        </div>
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
import store from '@/store'
import storage from 'store'
import { domTitle, setDocumentTitle } from '@/utils/domUtil'
import { i18nRender } from '@/locales'
export default {
  data() {
    return {
      // zh_CN,
    }
  },
  computed: {
    locale() {
      // 只是为了切换语言时，更新标题
      const { title } = this.$route.meta
      title && setDocumentTitle(`${i18nRender(title)} - ${domTitle}`)
      return this.$i18n.getLocaleMessage(this.$store.getters.lang).antLocale
    },
  },
}
</script>
<style lang='less' scoped>
.mask {
  position: fixed; 
  top: 0; 
  left: 0; 
  z-index: 99998;  
  width: 100%; 
  height: 100%;  
  background-color: #131212;
  opacity: 0.4; 
  // overflow: hidden;
}
.board {
  position: fixed; 
  top: 35%; 
  left: 35%;  
  width:20%;
  height: 35%; 
  // background: #ccc; 
  z-index: 99999;
  img {
    width: 50%;
    height: 50%;
  }
}
</style>